export default class config {
    public static wsUrl = "";
    public static limitActusCarousel = 3;
    public static limitActus = 3;
    public static rootFolderPath = "exploreFiles"
    public static facebook = {
        appId: "835440836833122"
    }
}